import useSWR from 'swr';
import { analyticsService, ReportTimelineResponse } from '../services/analyticsService';

interface UseReportTimelineReturn {
  timeline: ReportTimelineResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

/** reportId === null disables the fetch (no report selected yet). */
export const useReportTimeline = (reportId: string | null): UseReportTimelineReturn => {
  const { data, error, isLoading } = useSWR<ReportTimelineResponse, Error>(
    reportId ? `/api/v1/analytics/service/workflow/report/${reportId}` : null,
    () => analyticsService.getReportTimeline(reportId as string),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
    }
  );

  return {
    timeline: data,
    loading: isLoading,
    error,
  };
};
